{
  "pt": {
    "published": {
      "labels": {
        "notPublished": "Não publicado",
        "publishedCustomer": "Publicado para clientes",
        "publishedCustomerPartners": "Publicado para clientes e parceiros",
        "publishedPartners": "Publicado para parceiros"
      }
    }
  }
}
